import ItemTypeActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperItemType:null,
  errorInternal:false
};

function ItemTypeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ItemTypeActions.RESET_LIST:
      return INITIAL_STATE
    case ItemTypeActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case ItemTypeActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case ItemTypeActions.VIEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case ItemTypeActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case ItemTypeActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case ItemTypeActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case ItemTypeActions.SHOW_DATA:
      return { ...state,  errorInternal:false,onSubmit:false,isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case ItemTypeActions.SUCCESS_DATA:
      return { ...state,errorInternal:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case ItemTypeActions.PROCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: true, isError: false,isSuccess:false};
    case ItemTypeActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case ItemTypeActions.GET_HELPER_ITEMTYPE:
      return { ...state, errorInternal:false,isError: false,isSuccess:false,onSubmit:false,helperItemType:action.payload};
    case ItemTypeActions.ERROR_SERVER:
      return { ...state, onSubmit:false,  isError: false, errorInternal:true,  errorMessage: action.payload, isProcessing:false };
       
    default:
      return state;
    }
}

export default ItemTypeReducer;
